import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getFaqs = createAsyncThunk(
  "admin/allFaqs",
  async ({ page, limit, searchData, typeFilter }, { rejectWithValue }) => {
    try {
      let url = `/faq/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      if (typeFilter) {
        url += `&typeFilter=${typeFilter}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addFaq = createAsyncThunk(
  "admin/addFaq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/faq/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const editFaq = createAsyncThunk(
  "admin/editFaq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/faq/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getSingleFaq = createAsyncThunk(
  "admin/singleFaq",
  async (faqId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/faq/${faqId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteFaq = createAsyncThunk(
  "admin/deleteFaq",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/faq/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  faqData: [],
  singleFaqData: [],
};

const faqSlice = createSlice({
  name: "faqSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFaqs.fulfilled, (state, action) => {
      state.faqData = action.payload.data;
    });
    builder.addCase(getSingleFaq.fulfilled, (state, action) => {
      state.singleFaqData = action.payload.data;
    });
  },
});

export default faqSlice.reducer;


